<template>
  <v-row justify-center>
    <v-dialog :value="value" @input="$emit('input')" max-width="450">
      <v-card>
        <v-card-title class="headline" v-if="nota.notaVisita === '0'">{{ $t('addAnnotation.editarNota') }}</v-card-title>   
        <v-card-title class="headline" v-if="nota.notaVisita === '1'">{{ $t('addAnnotation.editarNotaVisita') }}</v-card-title>   
        <v-card-text text-xs-center class="text-xs-center">
          <v-flex xs12 pl-3 pr-3>
            <v-menu v-model="menuFecha" id="menuFecha" :close-on-content-click="false"
              :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="nota.date"
                  id="text-date"
                  :label="$t('addAnnotation.fecha')"
                  prepend-icon="event" v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="nota.date" id="date" @input="menuFecha = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-text-field v-model="nota.annotation" id="annotation" :label="$t('addAnnotation.nota')"></v-text-field>
        </v-card-text>
        <v-card-text v-if="nota.notaVisita === '1' "><v-icon text-xs-center x-medium color="amber">warning</v-icon> {{ $t('addAnnotation.avisoEditarNotaVisita')}} </v-card-text>
        <v-card-actions class="justify-center">
          <v-spacer></v-spacer>
          <v-btn text @click.native="$emit('input')">{{ $t('addAnnotation.cancelar') }}</v-btn>
          <v-btn color="red" :loading="saving" :disabled="saving" text @click="editAnnotation()">{{ $t('addAnnotation.editar') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
/*
annotation: newAnnotation.annotation,
date: newAnnotation.date,
id: newAnnotation.id
*/
import { mapActions } from 'vuex'
export default {
  props: {
    value: Boolean,
    nota: Object,
    incidence: String,
    notaVisita: String
  },
  data () {
    return {
      menuFecha: false,
      copyItem: {},
      fechaAnnotation: '',
      annotationText: '',
      annotationId: '',
      values: {},
      saving: false
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    ...mapActions({
      updateAnnotation: 'incidencias/updateAnnotation',
      getAnnotations: 'incidencias/getAnnotations'
    }),
    valueToEdit () {
      this.copyItem = {...this.nota}
      return this.copyItem
    },
    async editAnnotation () {
      this.loader = this.$loading.show({
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel
        })
      this.saving = true
      try {
        await this.updateAnnotation(this.nota, this.incidence)
        await this.getAnnotations(this.incidence)
        
        this.$emit('input')
        this.loader.hide()
      } catch (error) {
        // eslint-disable-next-line
      }
      this.saving = false
    }
  }
}
</script>